import * as React from 'react';
import type { Observable } from '@helpcenter/epics-rxjs';
import type { FieldFormProps, AttachmentFile } from '@helpcenter/field-types';
import { isEmpty } from 'lodash';
import type { SaveAttachmentResponse } from 'rest/attachments';
import type { MediaApiUploadToken } from 'rest/portal';
import { Attachments } from 'view/common/attachments';
import { FieldBase } from 'view/common/fields/field-base';
import type { AuthProvider } from '@atlaskit/media-core';

export interface Props extends FieldFormProps<AttachmentFile[]> {
    portalId: number;
    mediaApiUploadToken: MediaApiUploadToken;
    authProvider: AuthProvider;
    saveAttachment?: (fileId: string) => Observable<SaveAttachmentResponse>;
}

class RequestCreateAttachmentFieldDumb extends React.PureComponent<Props> {
    onChange = (value: AttachmentFile[]) => {
        this.props.onChange && this.props.onChange(this.props.id, value);
    };

    onError = (messages: string[]) => {
        this.props.onError &&
            this.props.onError({
                messages,
                name: this.props.id,
            });
    };

    render() {
        const {
            label,
            description,
            errorMessage,
            mediaApiUploadToken,
            blockFormSubmission,
            required,
            disabled,
            authProvider,
            saveAttachment,
            id,
        } = this.props;
        return (
            <FieldBase
                htmlFor={id}
                label={label}
                description={description}
                required={required}
                errorMessage={errorMessage}
            >
                <Attachments
                    onChange={this.onChange}
                    authProvider={authProvider}
                    collection={mediaApiUploadToken.targetCollection}
                    saveAttachment={saveAttachment}
                    blockFormSubmission={blockFormSubmission}
                    onError={this.onError}
                    disabled={disabled}
                    hasError={!isEmpty(errorMessage)}
                    aria-describedby={`${id}-field-description`}
                />
            </FieldBase>
        );
    }
}

export default RequestCreateAttachmentFieldDumb;
